import { combineReducers } from 'redux';
import user from './user';
import module from './module';

export default combineReducers({
  user,
  module,
});
